import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducers";
import { authenticationMiddleware } from "./middleware";
import { backendApi } from "./dynamicBAseQuery";
import { persistStore } from "redux-persist";

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
          serializableCheck: false,
        }).concat(authenticationMiddleware, backendApi.middleware),
})

export const persistor = persistStore(store)